'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProgressBar;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AssistiveText = require('./../AssistiveText');

var _AssistiveText2 = _interopRequireDefault(_AssistiveText);

var _normalizeValue = require('./normalizeValue');

var _normalizeValue2 = _interopRequireDefault(_normalizeValue);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Progress bar component communicates to the user the progress of a particular process.
 */


function ProgressBar(props) {
  var className = props.className,
      style = props.style,
      assistiveText = props.assistiveText,
      value = props.value,
      size = props.size,
      variant = props.variant;

  var getContainerClassNames = function getContainerClassNames() {
    return (0, _classnames2.default)('rainbow-progress-bar', 'rainbow-progress-bar--' + size, {
      'rainbow-progress-bar--success': variant === 'success'
    }, className);
  };

  var getProgressBarClassNames = function getProgressBarClassNames() {
    return (0, _classnames2.default)('rainbow-progress-bar_value', {
      'rainbow-progress-bar_value--success': variant === 'success'
    });
  };

  var normalizedValue = (0, _normalizeValue2.default)(value);
  var WIDTH = {
    width: normalizedValue + '%'
  };
  return _react2.default.createElement('div', {
    className: getContainerClassNames(),
    'aria-valuemin': '0',
    'aria-valuemax': '100',
    'aria-valuenow': normalizedValue,
    role: 'progressbar',
    style: style
  }, _react2.default.createElement('span', {
    className: getProgressBarClassNames(),
    style: WIDTH
  }, _react2.default.createElement(_AssistiveText2.default, {
    text: assistiveText
  })));
}

ProgressBar.propTypes = {
  /** The percentage value of the progress bar. It must be between 0 and 100. */
  value: _propTypes2.default.number,

  /** The size of the progress bar. Valid values are x-small, small, medium, and large.
   * The default value is medium. */
  size: _propTypes2.default.oneOf(['x-small', 'small', 'medium', 'large']),

  /** The variant of the progress bar. Valid values are brand and success. */
  variant: _propTypes2.default.oneOf(['brand', 'success']),

  /** A description for assistive sreen readers. */
  assistiveText: _propTypes2.default.string,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes2.default.string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes2.default.object
};
ProgressBar.defaultProps = {
  value: 0,
  size: 'medium',
  variant: 'brand',
  assistiveText: '',
  className: undefined,
  style: undefined
};